export default __webpack_public_path__ + "static/media/Pretendard-Medium.subset.2216ab02.woff";